export function cleanUpIllegalLinesBreaks(content) {
  // Replace patterns of \r, \n, or \r\n before and after HTML tags like <ul> and <ol>
  return content
    .replace(/[\r\n]+(?=<\/?(ul|ol|li)>)/g, "")
    .replace(/(?<=<\/?(ul|ol|li)>)[\r\n]+/g, "");
}
